import { Component, input } from '@angular/core';
import type { OnyxCustomAddress } from '@onyx/angular';
import { OnyxAddressComponent } from '@onyx/angular';

@Component({
  selector: 'app-points-of-interest-location-cell',
  imports: [OnyxAddressComponent],
  templateUrl: './points-of-interest-location-cell.component.html',
  styleUrl: './points-of-interest-location-cell.component.scss',
})
export class PointsOfInterestLocationCellComponent {
  public readonly address = input.required<OnyxCustomAddress | null>();
}
